<template>
  <div class="liquor-detail">
    <Header active="/liquor/browser" />
    <div class="top">
      <div class="left">
        <MultiMedia :list="util.getFileList(item.multimedia)" autoplay controls />
      </div>
      <div class="right">
        <div class="name">{{item.name}}</div>
        <span class="key-value">
          <div class="key" style="width: auto;">分类名称：</div>
          <div class="value">{{item.categoryName}}</div>
        </span>
        <span class="divider"></span>
        <span class="key-value">
          <div class="key" style="width: auto;">酒精度：</div>
          <div class="value">{{item.alcoholVolume}}</div>
        </span>
        <span class="divider"></span>
        <span class="key-value">
          <div class="key" style="width: auto;">净含量：</div>
          <div class="value">{{item.netWeight}}</div>
        </span>

        <div class="key-value" style="margin-top: 20px;">
          <div class="key" style="width: auto; font-size: 16px; color: black">建议零售价：</div>
          <div
            class="value"
            style="color: #C28B2B;font-size: 20px; font-family: DINMedium; font-weight: bold;"
          >{{util.formatMoney(item.price, 2, '￥')}}</div>
        </div>

        <div class="info-title">
          <div class="info-name">产地信息</div>
          <div class="area-more" @click="goto('/liquor/country/' + item.country)">
            查看产地更多酒类
            <img src="/liquor/menu_arrow@2x.png" alt=">" />
          </div>
        </div>
        <div class="key-value">
          <div class="key">年份：</div>
          <div class="value">{{item.productionYear}}</div>
        </div>
        <div class="key-value">
          <div class="key">原产国：</div>
          <div class="value">{{item.country}}</div>
        </div>
        <div class="key-value">
          <div class="key">产区：</div>
          <div class="value">{{item.area}}</div>
        </div>
        <div class="key-value">
          <div class="key">级别：</div>
          <div class="value">{{item.level ? item.level.split(' ').join('/') : ''}}</div>
        </div>
        <div class="key-value">
          <div class="key">酒庄品牌：</div>
          <div class="value">{{item.brand}}</div>
        </div>
        <div class="key-value">
          <div class="key">品牌特点：</div>
          <div class="value">{{item.brandFeatures}}</div>
        </div>
        <div class="key-value">
          <div class="key">葡萄品种：</div>
          <div class="value">{{item.grapeVariety}}</div>
        </div>
        <div class="info-title">
          <div class="info-name">储存收藏</div>
        </div>
        <div class="key-value">
          <div class="key">陈酿时间：</div>
          <div class="value">{{item.ageingTime}}</div>
        </div>
        <div class="key-value">
          <div class="key">储存条件：</div>
          <div class="value">{{item.storageConditions}}</div>
        </div>
        <div class="info-title">
          <div class="info-name">臻享品鉴</div>
        </div>
        <div class="key-value">
          <div class="key">饮用场景：</div>
          <div class="value">{{item.drinkingScene}}</div>
        </div>
        <div class="key-value">
          <div class="key">最佳饮用温度：</div>
          <div class="value">{{item.bestDrinkingTemperature}}</div>
        </div>
        <div class="key-value">
          <div class="key">醒酒时间：</div>
          <div class="value">{{item.hangoverTime}}</div>
        </div>
        <div class="key-value">
          <div class="key">建议配餐：</div>
          <div class="value">{{item.suggestedMeals}}</div>
        </div>
        <div class="key-value">
          <div class="key">酒评描述：</div>
          <div class="value">{{item.wineReview}}</div>
        </div>
      </div>
    </div>
    <DetailHeaderSelect :list.sync="headerSelectArray" :top="750" :title="item.name" />

    <div class="detail-content" v-show="headerSelectArray[0].active">
      <div v-html="item.detail"></div>
    </div>
    <div class="detail-discuss" v-show="headerSelectArray[1].active">
      <CommodityMarketingDiscuss
        theme="liquor"
        :showTitle="false"
        targetName="liquor"
        :bean="item"
        @submit="onCreateDiscuss"
        @change="onDiscussChange"
        @like="onLike"
      />
    </div>
    <Sticky />
  </div>
</template>

<script>
import Header from "@/components/liquor/Header";
import Sticky from "@/components/liquor/Sticky";
import LiquorDetailHeader from "@/components/liquor/LiquorDetailHeader";
import DetailHeaderSelect from "@/components/liquor/DetailHeaderSelect";
import LiquorDetailIntroduction from "@/components/liquor/LiquorDetailIntroduction";

import MultiMedia from "@/components/liquor/MultiMedia";
import CommodityMarketingDiscuss from "@/components/CommodityMarketingDiscuss";

export default {
  name: "LiquorDetail",
  components: {
    Header,
    LiquorDetailHeader,
    DetailHeaderSelect,
    LiquorDetailIntroduction,
    Sticky,
    MultiMedia,
    CommodityMarketingDiscuss
  },
  data() {
    return {
      item: {
        name: "",
        multimedia: ""
      },
      headerSelectArray: [
        {
          name: "商品详情",
          link: "/liquor/detail",
          active: true
        },
        {
          name: "三言两语",
          link: "/liquor/detail",
          active: false
        }
      ]
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.ajax
        .doPost({
          packageName: "liquor",
          className: "liquorCommodity",
          methodName: "get",
          params: {
            id: this.$route.params.id
          }
        })
        .then(response => {
          this.item = response;
        });

      this.$store.dispatch("userCommentPage", {
        packageName: "user",
        className: "userComment",
        methodName: "getCommentsByTargetWithMe",
        params: {
          targetName: "liquor",
          targetId: this.$route.params.id,

          numPerPage: 3
        }
      });

      // window.addEventListener("scroll", this.handleScroll, true);
    },
    handleScroll(e) {
      console.log(e.target.documentElement.scrollTop);
    },
    goto(path) {
      this.$router.push(path);
    },
    async onCreateDiscuss(e) {
      await this.$store.dispatch("createComment", {
        packageName: "user",
        className: "userComment",
        methodName: "create",
        params: {
          ...e
        }
      });

      this.$message.success("评论成功！");

      this.$store.dispatch("userCommentPage", {
        packageName: "user",
        className: "userComment",
        methodName: "getCommentsByTargetWithMe",
        params: {
          targetName: "liquor",
          targetId: this.$route.params.id,

          numPerPage: 3
        }
      });
    },
    async onLike(e) {
      await this.$store.dispatch("createLike", {
        packageName: "user",
        className: "userLike",
        methodName: "create",
        params: {
          targetName: "comment",
          targetId: e.id
        }
      });

      this.$message.success("点赞成功！");
    },
    onDiscussChange(e) {
      this.$store.dispatch("userCommentPage", {
        packageName: "user",
        className: "userComment",
        methodName: "getCommentsByTargetWithMe",
        params: {
          targetName: "liquor",
          targetId: this.$route.params.id,

          pageNum: e,
          numPerPage: 3
        }
      });
    }
  }
};
</script>

<style lang="scss">
.liquor-detail {
  .top {
    width: 1100px;
    margin: 110px auto 20px auto;
    padding-bottom: 30px;
    border-bottom: 1px solid #d8d8d8;
    .left {
      width: 538px;
      display: inline-block;
      vertical-align: top;
      margin-right: 40px;
    }

    .right {
      display: inline-block;
      vertical-align: top;
      max-width: 522px;
      .name {
        font-size: 30px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(0, 0, 0, 1);
        line-height: 33px;
        margin-bottom: 15px;
      }

      .info-title {
        margin-top: 30px;
        margin-bottom: 15px;
        .info-name {
          display: inline-block;
          height: 25px;
          background: rgba(228, 200, 150, 1);
          font-size: 12px;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
          line-height: 25px;
          padding: 0 13px;
        }

        .area-more {
          float: right;
          cursor: pointer;
          text-align: center;
          width: 122px;
          height: 23px;
          border: 1px solid rgba(228, 200, 150, 1);
          font-size: 12px;
          font-weight: 400;
          color: rgba(194, 139, 43, 1);
          line-height: 23px;

          img {
            margin-left: 3px;
            width: 4px;
            height: 7px;
          }
        }
      }

      .key-value {
        margin-top: 5px;
        .key {
          width: 120px;
          display: inline-block;
          vertical-align: top;
          height: 20px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(132, 135, 145, 1);
          line-height: 20px;
        }

        .value {
          max-width: 400px;
          display: inline-block;
          vertical-align: top;
          font-size: 14px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 20px;
        }
      }

      .divider {
        display: inline-block;
        margin: 0 20px;
        width: 1px;
        height: 14px;
        background: rgba(204, 204, 204, 1);
      }
    }
  }

  .detail-content {
    width: 1100px;
    margin: 0 auto;
  }

  .detail-discuss {
    width: 1100px;
    margin: 0 auto;
  }
}
</style>

<style lang="scss" scoped>
.liquor-detail {
  .liquor-header-parent {
    background: rgba(0, 0, 0, 1);
  }
}
</style>

<style lang="scss">
.liquor-detail {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #e4c896;
    border-color: #e4c896;
  }
}
</style>